

export const isElementVisible = (elem: HTMLElement): boolean => elem
    ? Boolean(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length)
    : false;
